import { APP_INITIALIZER, ErrorHandler, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { environment } from '../environments/environment';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatSidenavModule } from '@angular/material/sidenav';
import { HttpClientModule } from '@angular/common/http';
import { SidenavModule } from './features/sidenav/sidenav.module';
import { NavModule } from './features/nav/nav.module';

import { AngularFireAuthModule } from '@angular/fire/compat/auth';
import { AngularFireModule } from '@angular/fire/compat';
import { AngularFireFunctionsModule } from '@angular/fire/compat/functions';
import { provideFirestore, getFirestore } from '@angular/fire/firestore';
import { provideFunctions, getFunctions } from '@angular/fire/functions';
import { provideAuth, getAuth } from '@angular/fire/auth';
import { AuthModule } from './features/auth/auth.module';
import { DatePipe } from '@angular/common';
import { IdbService } from './core/services/idb/idb.service';
import { AuthenticationService } from './core/services/authentication/authentication.service';
import { NgxMaskModule } from 'ngx-mask';
import * as Sentry from '@sentry/angular';
import { Router } from '@angular/router';
import { GlobalErrorHandler } from './shared/handlers/global-error-handler';

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    AngularFireAuthModule,
    AngularFireModule.initializeApp(environment.firebase),
    //provideFirebaseApp(() => initializeApp(environment.firebase)), not sure if needed
    provideAuth(() => getAuth()),
    provideFirestore(() => getFirestore()),
    provideFunctions(() => getFunctions()),
    AngularFireFunctionsModule,
    BrowserAnimationsModule,
    MatSidenavModule,
    HttpClientModule,
    SidenavModule,
    NavModule,
    AuthModule,
    NgxMaskModule.forRoot(),
  ],
  providers: [
    DatePipe,
    {
      provide: APP_INITIALIZER,
      useFactory: initializeAccutrax,
      deps: [IdbService, AuthenticationService, Sentry.TraceService],
      multi: true,
    },
    { provide: Sentry.TraceService, deps: [Router] },
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}

export function initializeAccutrax(idb: IdbService): () => Promise<void> {
  return (): Promise<void> => {
    return new Promise((resolve, reject) => {
      console.log('Initializing Accutrax');
      const idbInit = idb
        .initIdb()
        .then(() => {
          console.log('IDB Initialized');
        })
        .then(() => {
          resolve();
        })
        .catch(() => {
          reject();
        });
      return idbInit;
    });
  };
}
